import React from 'react';

export const OptOut = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        clipRule="evenodd"
        d="M15.9226 6.75583L15.4726 7.20583C15.0693 7.61 14.5309 7.83333 13.9584 7.83333H9.20844C8.63594 7.83333 8.09761 7.61 7.69344 7.205L7.24427 6.75583C6.91844 6.43 6.91844 5.90333 7.24427 5.5775C7.57011 5.25167 8.09677 5.25167 8.42261 5.5775L8.87261 6.0275C8.96261 6.11667 9.08177 6.16667 9.20844 6.16667H13.9584C14.0851 6.16667 14.2043 6.11667 14.2934 6.02833L14.7443 5.5775C15.0701 5.25167 15.5968 5.25167 15.9226 5.5775C16.2484 5.90333 16.2484 6.43 15.9226 6.75583ZM20.3334 4.5C20.3334 3.12167 19.2118 2 17.8334 2H4.50011C3.12177 2 2.00011 3.12167 2.00011 4.5V9.5H20.3334V4.5Z"
        fill="black"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M15.1021 11.1667H2.00042V16.1667C2.00042 17.545 3.12126 18.6667 4.50042 18.6667H12.0004V16.1667C12.0004 15.3667 12.3779 14.6542 12.9638 14.1958C13.2596 12.93 14.0471 11.8608 15.1021 11.1667Z"
        fill="black"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M16.1667 15.3333C16.1667 14.4142 16.9142 13.6667 17.8333 13.6667C18.7525 13.6667 19.5 14.4142 19.5 15.3333H16.1667ZM21.1667 15.3333C21.1667 13.495 19.6717 12 17.8333 12C15.995 12 14.5 13.495 14.5 15.3333C14.04 15.3333 13.6667 15.7067 13.6667 16.1667V21.1667C13.6667 21.6267 14.04 22 14.5 22H21.1667C21.6267 22 22 21.6267 22 21.1667V16.1667C22 15.7067 21.6267 15.3333 21.1667 15.3333Z"
        fill="black"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect fill="white" height="20" transform="translate(2 2)" width="20" />
      </clipPath>
    </defs>
  </svg>
);
